import { Controller } from "@hotwired/stimulus"
import { productTourRunning } from "./product_tour_controller"

// FD-1197: the first-time feature overlay (shared/_feature_tour). Opens itself once the page
// is up, and marks the feature seen when the dialog closes, however it closes: Got it, Escape
// or the backdrop. One POST, fire and forget; if it fails the person just sees the tour once
// more next time, which beats a dialog that won't go away. The server renders the dialog
// only while the feature is unseen, so a seen tour costs the page nothing.
//
// FD-1251: never during the guided tour (product_tour_controller.js), which already has its
// panel on the page. If the tour is running when the timer fires, the dialog is removed
// unopened, so nothing can close it and mark the feature seen: the person still gets it the
// first time they open the page on their own. Asked when the timer fires, not at connect,
// because the tour's controller connects after this one and only then saves a ?tour=n step.
export default class extends Controller {
  static values = { url: String, feature: String }

  connect() {
    // After the first paint, so the page behind it is there to point at.
    this.openTimer = setTimeout(() => {
      if (!this.element.isConnected || this.element.open) return
      if (productTourRunning()) this.element.remove()
      else this.element.showModal()
    }, 300)
  }

  disconnect() {
    clearTimeout(this.openTimer)
  }

  seen() {
    if (this.sent) return
    this.sent = true
    const token = document.querySelector('meta[name="csrf-token"]')?.content || ""
    fetch(this.urlValue, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": token },
      body: JSON.stringify({ feature: this.featureValue }),
      credentials: "same-origin"
    }).catch(() => {})
  }
}
